<template>
  <div :class="['panel', 'panel-' + color]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'panel',
  props: {
    color: {
      default: 'default',
      type: String
    }
  }
};
</script>

<style>
.panel {
  background-color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Panel/Panel.vue